import { useEffect, useState } from "react"
import styled from "styled-components"
import ErrorableInputWrapper from "../common/ErrorableInputWrapper"
import LabeledInput from "../LabeledInput"
import MainButton from "../../atoms/MainButton"
import { validatePassword, validatePhoneNumber } from "../../../utils/userValidation"
import { registerUser, loginUser } from "../../../api/auth"
import { useNavigate } from "react-router-dom"
import PasswordFieldGroup from "./PasswordFieldGroup"
import { logEvent } from "../../../utils/eventLogger"

const Wrapper = styled.form`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px; 
`
const ButtonWrapper = styled.div`
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 600px; /* Wrapper 최대 폭과 맞춤 */
  padding: 0 20px;   /* 좌우 여유 */
`

const UserInfoStep = ({userInfo, setUserInfo, tos}) => {
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const navigate = useNavigate();

  // 에러 메시지 상태관리
  const [errors, setErrors] = useState({
    name: '',
    password: '',
    passwordConfirm: '',
    phoneNumber: ''
  })

   // input 이벤트 핸들러
  const handleChange = (field) => (e) => {
    let value = e.target.value;

    if (field === 'phoneNumber') {
      // 숫자만 남기기
      const onlyNums = value.replace(/[^0-9]/g, '');
      
      // 하이픈 자동 생성
      if (onlyNums.length <= 3) value = onlyNums;
      else if (onlyNums.length <= 7) value = `${onlyNums.slice(0, 3)}-${onlyNums.slice(3)}`;
      else value = `${onlyNums.slice(0, 3)}-${onlyNums.slice(3, 7)}-${onlyNums.slice(7, 11)}`;
    }

    setUserInfo(prev => ({ ...prev, [field]: value }));

    // 입력을 시작하면 해당 필드의 에러 메시지 초기화
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: '' }));
    }

  }

  const handleChangeConfirm = (e) => {
    const value = e.target.value;
    setPasswordConfirm(value);

    if (errors.passwordConfirm) {
      setErrors(prev => ({ ...prev, passwordConfirm: '' }));
    }
  };

  // focus를 벗어날 때 유효성 검증 후 에러 메시지 표시
  const handleBlur = (field) => {
    let error = '';
    if (field === 'name') {
      if (!userInfo.name?.trim()) error = "이름을 입력해주세요.";
      else if (userInfo.name.length < 2) error = "이름은 최소 2자 이상입니다.";
    }
     if (field === 'password') {
      if (!userInfo.password?.trim()) error = "비밀번호를 입력해주세요.";
      else if (!validatePassword(userInfo.password)) error = "비밀번호는 숫자/영문/특수문자 중 2가지 조합이며 최소 8자 이상 입니다.";
    }
    if (field === 'passwordConfirm') {
      if (!passwordConfirm.trim()) {
        error = "비밀번호 확인을 입력해주세요.";
      } else if (userInfo.password !== passwordConfirm) {
        error = "비밀번호가 일치하지 않습니다.";
      }
    }
    if (field === 'phoneNumber') {
      if (!userInfo.phoneNumber?.trim()) error = "휴대폰 번호를 입력해주세요.";
      else if (!validatePhoneNumber(userInfo.phoneNumber.replace(/-/g, ''))) error = "올바른 휴대폰 번호를 입력해주세요.";
    }
    setErrors(prev => ({ ...prev, [field]: error }));
  };
  
  const handleBlurPassword = () => handleBlur('password');
  const handleBlurConfirm = () => handleBlur('passwordConfirm');


  // useEffect(() => {
  //   if (!passwordConfirm) return;

  //   const error =
  //     userInfo.password === passwordConfirm
  //       ? ""
  //       : "비밀번호가 일치하지 않습니다.";

  //   setErrors(prev => ({
  //     ...prev,
  //     passwordConfirm: error
  //   }));
  // }, [userInfo.password, passwordConfirm]);

  useEffect(() => {
    if (userInfo.password === passwordConfirm) {
      setErrors(prev => ({
        ...prev,
        passwordConfirm: ""
      }));
    }
  }, [userInfo.password, passwordConfirm]);

  const handleSubmit = async(e) => {
    e?.preventDefault();
    if (!isBtnValid) return;

    const data = {
    ...userInfo,
    // '-' 하이픈 제거
    phoneNumber: userInfo.phoneNumber.replace(/-/g, ''),
    tos
    };

    const loginData = {
      email : userInfo.email,
      password : userInfo.password
    };

    try {
      await registerUser(data)
      /* 아이등록에 필요한 유저 정보 필요
         ex. 회원가입 api 호출 시 로그인 토큰 반환, 자동 로그인 */
      // console.log('회원가입 성공')

      // 회원가입 후 자동 로그인
      await loginUser(loginData)
      
       // 로그 기록
      logEvent("signup_complete", {
        extractChildId: false
      })

      // 회원가입 성공 후 localStorage 초기화
      sessionStorage.removeItem('emailVerified')
      sessionStorage.removeItem('termsAgreed')
      sessionStorage.removeItem('terms')
      sessionStorage.removeItem('userInfo')

      // 로그 기록
      logEvent("children_register_start")

      // 완료 후 자녀 등록 페이지 이동
      navigate('/signup/child-register')
    } catch (err) {
      // console.log('회원가입 실패')
      console.error(err);
    }
  }

  // const isBtnValid =
  //   userInfo.name?.trim() &&
  //   !errors.name &&
  //   userInfo.email&&
  //   userInfo.password?.trim() &&
  //   !errors.password &&
  //   passwordConfirm?.trim() &&
  //   !errors.passwordConfirm &&
  //   userInfo.phoneNumber?.trim() &&
  //   !errors.phoneNumber;

  // 버튼 활성화 여부는 에러 상태가 아닌 즉각적인 검증 결과를 통해 결정
  const isBtnValid =
    userInfo.name?.trim().length >= 2 &&
    userInfo.email &&
    validatePassword(userInfo.password || '') &&
    passwordConfirm?.trim() && 
    userInfo.password === passwordConfirm &&
    validatePhoneNumber(userInfo.phoneNumber?.replace(/-/g, '') || '');

  return (
    <Wrapper onSubmit={handleSubmit}>
      <ErrorableInputWrapper $error={!!errors.name} message={errors.name}>
        <LabeledInput
          name="name"
          autoComplete="name"
          label="이름"
          placeholder="이름 입력"
          value={userInfo.name}
          required={true}
          onChange={handleChange('name')}
          onBlur={()=>handleBlur('name')}
          $error={!!errors.name}/>
      </ErrorableInputWrapper>
      <ErrorableInputWrapper>
        <LabeledInput
          name="email"
          autoComplete="email"
          type="email"
          label="이메일"
          value={userInfo.email}
          required={true}
          readOnly={true}/>
      </ErrorableInputWrapper>
      {/* <ErrorableInputWrapper error={!!errors.password} message={errors.password}>
        <LabeledInput
          type="password"
          label="비밀번호"
          placeholder="숫자/영문/특수 문자 조합, 8자 이상"
          value={userInfo.password}
          required={true}
          onChange={handleChange('password')}
          onBlur={()=>handleBlur('password')}
          error={!!errors.password}/>
      </ErrorableInputWrapper> */}
      <PasswordFieldGroup
        password={userInfo.password}
        passwordConfirm={passwordConfirm}
        onChangePassword={handleChange('password')}
        onChangeConfirm={handleChangeConfirm}
        onBlurPassword={handleBlurPassword}
        onBlurConfirm={handleBlurConfirm}
        errorPassword={errors.password}
        errorPasswordConfirm={errors.passwordConfirm}
        autoComplete="new-password"/>
      <ErrorableInputWrapper $error={!!errors.phoneNumber} message={errors.phoneNumber}>
        <LabeledInput
          name="phoneNumber"
          autoComplete="tel"
          type="tel"
          label="전화번호"
          placeholder="휴대폰 번호 입력"
          value={userInfo.phoneNumber}
          required={true}
          onChange={handleChange('phoneNumber')}
          onBlur={()=>handleBlur('phoneNumber')}
          $error={!!errors.phoneNumber}
          maxLength={13}/>
      </ErrorableInputWrapper>
      <ButtonWrapper>
        <MainButton 
          $variant="primary"
          title="다음"
          disabled={!isBtnValid}
          type="submit"/>
      </ButtonWrapper>
    </Wrapper>
  )
}

export default UserInfoStep
